import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/Button'
import Input from 'components/Input'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import workoutMessages from 'modules/workout/redux/messages'

export function ExerciseNotes ({
  note,
  isNoteVisible,
  onNoteChange,
  onToggleNoteVisibility,
  onNoteDone
}) {
  const intl = useIntl()

  return (
    <View mt={2}>
      {isNoteVisible
        ? (
          <View>
            <Input
              isFocused
              type='text'
              value={note}
              onChange={onNoteChange}
              style={{
                width: '100%',
                border: '1px solid #0000003b',
                backgroundColor: '#F6F6F6',
                fontSize: '1.1em'
              }}
            />
            <View
              mt
              style={{ alignItems: 'end' }}
            >
              <Button
                onClick={onNoteDone}
                style={{
                  width: 'fit-content',
                  height: 'unset'
                }}
              >
                <Text
                  c='#4C68CB'
                  fs='1.1em'
                >
                  {formatMessageIntlUtil(intl, workoutMessages.done)}
                </Text>
              </Button>
            </View>
          </View>
          )
        : (
          <Button
            onClick={onToggleNoteVisibility}
            style={{
              width: '100%',
              height: 'unset',
              textAlign: 'left'
            }}
          >
            <Text fs='1.1em'>
              {note || formatMessageIntlUtil(intl, workoutMessages.addExerciseAllSet)}
            </Text>
          </Button>
          )}
    </View>
  )
}

ExerciseNotes.propTypes = {
  note: PropTypes.string.isRequired,
  isNoteVisible: PropTypes.bool.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onToggleNoteVisibility: PropTypes.func.isRequired,
  onNoteDone: PropTypes.func.isRequired
}
